module.exports = __webpack_public_path__ + "static/img/tj.4891f0a0.svg";